module.exports = __webpack_public_path__ + "img/img-6.53710d0a.webp";